import { strings } from '../context/LanguageContext/strings'
export const customConstants = {
    endList: ['Never', 'Until', 'Count'],
    getRepeatList: () => [
        {
            repeat: 'Does Not Repeat',
            display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_NOT_REPEAT,
        },
        {
            repeat: 'Weekly',
            display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_SCHEDULE_WEEKLY,
        },
    ],
    ocurrenceList: ['First', 'Second', 'Third', 'Fourth', 'Last'],
    months: {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December',
    },
    getDays: () => {
        return {
            SUN: strings.SUNDAY,
            MON: strings.MONDAY,
            TUE: strings.TUESDAY,
            WED: strings.WEDNESDAY,
            THU: strings.THURSDAY,
            FRI: strings.FRIDAY,
            SAT: strings.SATURDAY,
        }
    },
    getWeekDays: () => [
        { value: 'sun', display: strings.SUNDAY },
        { value: 'mon', display: strings.MONDAY },
        { value: 'tue', display: strings.TUESDAY },
        { value: 'wed', display: strings.WEDNESDAY },
        { value: 'thu', display: strings.THURSDAY },
        { value: 'fri', display: strings.FRIDAY },
        { value: 'sat', display: strings.SATURDAY },
    ],
    networkErrors: {
        genericError: 'We are sorry, but an unexpected error has occurred. Please try again.',
        Network_Error: 'There is a Network issue, Please check your Internet Connection',
        Internal_Server_Error: 'An Error Occurred. Please try again.',
        timeout_of_0ms_exceeded: 'An Error Occurred. Please try again.',
        Request_failed_with_status_code_500: 'An Error Occurred. Please try again.',
        Request_failed_with_status_code_400: 'An Error Occurred. Please try again.',
        Payload_insufficient: 'An Error Occurred. Please try again.',
    },

    PROMO_COLORS: [
        '#32C5FF',
        '#44D7B6',
        '#F8CC46',
        '#9861D8',
        '#FA6400',
        '#425AF6',
        '#C7B556',
        '#EA4161',
        '#EC69C0',
        '#A8D04B',
    ],
    color: {
        success_green: 'rgba(65,164,75,1)',
        orange: 'rgba(238,113,2,1)',
        red: 'rgba(236,37,38,1)',
    },
    hstTimeZone: 'Pacific/Honolulu',
}
